import {useContext} from "react";
import {ConfigurationContext} from "contexts";

const scanTimeout = 120000; // Two minutes.

export const useNetworkDetection = (
    onProgress,
    onDone,
    onError,
    latencyDetection,
    speedDetection
) => {
    let config = useContext(ConfigurationContext);

    const run = () => {
        // Configure the host.
        var subDomain = window.location.hostname
            .toLowerCase()
            .replace(".systemrequirementslab.com", "");
        if (
            subDomain !== "test.cyri" &&
            subDomain !== "prod.cyri" &&
            subDomain !== "www"
        ) {
            subDomain = "www";
        }

        // Set the detection settings.
        window.SRL.detection.init({
            loggingLevel: config.loggingLevel,
            host: subDomain, // window.location.hostname.toLowerCase().replace(".systemrequirementslab.com",""),
            //      host: "www",
            protocol: "https",
            referrerId: config.referrerId,
            onProgress: onProgress,
            onError: onError,
            onDone: onDone,
            scanSpeedTest: false,
            scanNetworkLatency: latencyDetection,
            scanNetworkSpeed: speedDetection,
            networkScanTimeout: scanTimeout,
            computerId: config.computerId,

            latencyTestEndpoint: config.networkTestEndpoints.latency,
            speedTestEndpoint: config.networkTestEndpoints.speed,

            networkTestService: config.detection.networkTestService,
            requirementSetId: config.requirementSetId,
        });

        //.then(() => {
        // Run the detection.
        window.SRL.detection.runNetworkScan().then(() => {
            console.log("Network detection is done.");
        })
            .catch((error) => {
                console.log("Caught error: " + error.message);
            });
        //})
    };

    return run;
};
